const moment = require("moment-timezone");

const isNumber = (value) => typeof value === 'number' && isFinite(value);
const monthsOldFloat = (iso, tz = "America/Los_Angeles") => {
  const birth = moment.parseZone(iso).tz(tz);
  const now = moment.tz(tz);
  return now.diff(birth, "months", /* precise */ true); // returns a float
}

/**
 * Calculate the count of different types of pets from the given data
 * @param {Array} petsData - Array of pet objects
 * @returns {Object} Object containing counts of dogs, cats, and puppies
 */
export function calculatePetCounts(petsData) {
  if (
    petsData
    && isNumber(petsData?.cats)
    && isNumber(petsData.dogs)
    && isNumber(petsData.puppies)
  ) {
    return petsData; // Already in desired format
  }

  if (!Array.isArray(petsData)) {
    return { dogs: 0, cats: 0, puppies: 0 };
  }

  let dogs = 0;
  let cats = 0;
  let puppies = 0;

  petsData.forEach(pet => {
    if (pet.type === 'dog') {
      // Check if it's a puppy (less than 1 year old)
      if (pet.birthmonth && pet.birthyear) {
        const birthDateStr = `${pet.birthyear}-${String(pet.birthmonth).padStart(2, '0')}-15`; // Use 15th as mid-month

        /*
        const birthDate = new Date(pet.birthdate);
        const currentDate = new Date();
        const ageInMonths =
          (currentDate.getFullYear() - birthDate.getFullYear()) * 12 +
          (currentDate.getMonth() - birthDate.getMonth());
        */

        if (monthsOldFloat(birthDateStr) < 18) {
          puppies++;
        } else {
          dogs++;
        }
      } else if (pet.birthdate) {
        if (monthsOldFloat(pet.birthdate) < 18) {
          puppies++;
        } else {
          dogs++;
        }
      } else {
        // If no birthdate, assume adult dog
        dogs++;
      }
    } else if (pet.type === 'cat') {
      cats++;
    }
  });

  return { dogs, cats, puppies };
}

export const colorPalette = {
  // Matching the green chip's saturation pattern (light bg, dark text)
  booking: { bg: '#f5e6e1', text: '#8c3719' },        // Light peach bg, dark brown text
  requested: { bg: '#e3f2fd', text: '#1565c0' },      // Light blue bg, dark blue text  
  accepted: { bg: '#e8f5e8', text: '#2e7d32' },       // Light green bg, dark green text (reference)
  bookingConfirmed: { bg: '#ffebee', text: '#c62828' }, // Light pink bg, dark red text
  declined: { bg: '#f5f5f5', text: '#616161' },       // Light gray bg, dark gray text
  cancelled: { bg: '#fff3e0', text: '#ef6c00' },      // Light orange bg, dark orange text
};

export const getBookingStatusColor = (status, processName) => {
  if (processName === 'default-booking') {
    switch (status) {
      case 'transition/decline':
      case 'transition/provider-decline':
      case 'transition/operator-decline':
      case 'declined':
        return {
          text: colorPalette.declined.text, // Gray
          bg: colorPalette.declined.bg,
        };
      case 'transition/cancel':
      case 'transition/cancel-by-customer':
      case 'transition/expire-payment':
      case 'cancelled':
        return {
          text: colorPalette.cancelled.text, // Orange
          bg: colorPalette.cancelled.bg,
        };
      default:
        return {
          text: colorPalette.booking.text, // Dark brown for all lead statuses
          bg: colorPalette.booking.bg,
        };
    }
  }
  switch (status) {
    case 'transition/accept':
    case 'accepted':
      return {
        text: colorPalette.accepted.text, // Green
        bg: colorPalette.accepted.bg,
      };
    
    case 'transition/confirm-payment':
    case 'transition/initiate-booking':
    case 'booking-initiated':
      return {
        text: colorPalette.bookingConfirmed.text, // Red
        bg: colorPalette.bookingConfirmed.bg,
      };
    case 'transition/confirm-booking':
    case 'booking-confirmed':
      return {
        text: colorPalette.booking.text, // Red
        bg: colorPalette.booking.bg,
      };
    case 'transition/decline':
    case 'transition/provider-decline':
    case 'transition/operator-decline':
    case 'declined':
      return {
        text: colorPalette.declined.text, // Gray
        bg: colorPalette.declined.bg,
      };
    case 'transition/cancel':
    case 'transition/cancel-by-customer':
    case 'transition/expire-payment':
    case 'cancelled':
      return {
        text: colorPalette.cancelled.text, // Orange
        bg: colorPalette.cancelled.bg,
      };
    default:
      return {
        text: colorPalette.requested.text, // Blue
        bg: colorPalette.requested.bg,
      };
  }
};